import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGoogleMcpSettings } from "./app-settings-config-google-mcp";

export interface IConfigGoogleMcpInputState {
  showModal: boolean;
  editingGoogleMcpId: string;
}

export interface IConfigGoogleMcpInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGoogleMcpInput extends PureComponent<IConfigGoogleMcpInputProps, IConfigGoogleMcpInputState> {
  formInputName: string[] = ["apiConfig", "googleMcpSettingsId"];

  constructor(props: IConfigGoogleMcpInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingGoogleMcpId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingGoogleMcpId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingGoogleMcpId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigGoogleMcpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingGoogleMcpId={this.state.editingGoogleMcpId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Google"
          formInputName={this.formInputName}
          options={this.props.commonSettings.googleMcpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_googlemcp"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpGoogleDropdown"
          addNewTestId="appSettingsMcpGoogleAddNewButton"
          editTestId="appSettingsMcpGoogleEditButton"
        />
      </>
    );
  }
}
